// src/utils.ts
var Any = class {
};
export {
  Any
};
